<template>
  <div class="flex flex-col h-full">
    <div class="px-4 py-2.5 bg-white flex items-center gap-3" style="border-bottom: 1px solid #E8E9E9;">
      <h2 class="text-lg font-semibold" style="color: #353537;">Operations V2</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quality_Operations_V2',
};
</script>
